import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from "advanced-laravel-vue-paginate";
import "advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "SalaryChangesHistoryList",
  components: {
    MainLayout,
    AdvancedLaravelVuePaginate,
    Loading
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      records: [],
      pagination: {},
      isFilterOpen: false,
      isLoading: false,
      currency: this.$store.state.setting.currency || 'MMK',
      searchData: {
        employee_name: '',
      },
      searchedData: {
        employee_name: '',
      },
    }
  },

  methods: {
    getList(page = 1) {
      this.isLoading = true;

      axios.get('salaryHistory/changesHistory/list', {
          params: {
            page: page,
            employee_name: this.searchedData.employee_name || undefined,
          }
        }).then(res => {
          if (page > 1 && !res.data.data.length) {
            this.getList(page - 1);
            return;
          }

          this.pagination = res.data;
          this.records = res.data.data;
        }).catch(err => {
          if (err.response && err.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    search() {
      this.searchedData = {
        employee_name: this.searchData.employee_name,
      };
      this.getList(1);
    },

    reset() {
      this.searchData = {
        employee_name: '',
      };
      this.searchedData = {
        employee_name: '',
      };
      this.getList(1);
    },

    del(id) {
      if (!confirm("Are you sure you want to delete?")) return;

      this.isLoading = true;

      axios.delete(`salaryHistory/changesHistory/delete/${ id }`)
      .then(() => {
        this.getList(this.pagination.current_page);

        this.$notification.success("Salary Changes History Deleted Successfully.", {
          timer: 3,
          position: "bottomCenter",
        });
      }).catch(err => {
        if (err.response && err.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }

        if (err.response && err.response.status == 422) {
          const message = err.response.data?.error || "Invalid Salary Changes History.";
          this.$notification.error(message, {
            timer: 3,
            position: "bottomCenter",
          });
        }
        this.isLoading = false;
      });
    },

    getRowSpan(employeeNumber) {
      var result = this.records.filter(rec => rec.employee_number === employeeNumber).length;
      return result;
    },

    isSameRecordBefore(employeeNumber, index) {
      var result = this.records[index - 1]?.employee_number === employeeNumber;
      return result;
    },
  },

  mounted() {
    this.isLoading = true;
    this.getList();
  },
};
